import { render, staticRenderFns } from "./epb-modal-wrapper.component.vue?vue&type=template&id=66dfdab0&scoped=true"
import script from "./epb-modal-wrapper.component.vue?vue&type=script&lang=ts"
export * from "./epb-modal-wrapper.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-modal-wrapper.component.vue?vue&type=style&index=0&id=66dfdab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66dfdab0",
  null
  
)

export default component.exports